import { render, staticRenderFns } from "./ItemDetailLabour.vue?vue&type=template&id=04666916&scoped=true"
import script from "./ItemDetailLabour.vue?vue&type=script&lang=js"
export * from "./ItemDetailLabour.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailLabour.vue?vue&type=style&index=0&id=04666916&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04666916",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04666916')) {
      api.createRecord('04666916', component.options)
    } else {
      api.reload('04666916', component.options)
    }
    module.hot.accept("./ItemDetailLabour.vue?vue&type=template&id=04666916&scoped=true", function () {
      api.rerender('04666916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/item/ItemDetailLabour.vue"
export default component.exports